/**
 * 登录相关的路由
 *
 * /login: 企业微信扫码登录
 * /accountLogin: 账号密码登录
 * /login: 商业登录
 * /registration: 注册账号
 * /resetPassword: 重置密码
 */
export const loginPageRoutes = [
  '/8c23181b9bee9cbe5b594e62ee75b671',
  '/accountLogin',
  '/login',
  '/registration',
  '/resetPassword',
  '/loginAsync',
];

/**
 * 页面默认title
 */

/**
 * mode 取值的含义
 *
 * default: 默认布局，侧边菜单，顶部导航，顶部菜单均展示
 * simple: 简约布局，侧边菜单，顶部骨架展示，顶部菜单不展示
 * single: 单页布局，仅展示顶部骨架，侧边菜单，顶部菜单均不展示
 * onlyContent: 仅内容布局，仅展示内容区域，侧边菜单，顶部导航，顶部菜单均不展示
 */

/**
/**
 * 可以展示侧边菜单的 mode
 */
export const canShowSiderBarMode = ['default', 'simple'];

/**
 * 可以展示顶部导航栏的 mode
 */
export const canShowTopBarMode = ['default', 'simple', 'single'];

/**
 * 可以展示顶部导航菜单的 mode
 */
export const canShowTopMenuMode = ['default'];

/**
 * 顶部菜单容器宽度
 *
 * 200 左侧 logo 宽度，20 菜单的左侧margin，36 右侧头像宽度，20 头像左侧margin，20 头像右侧margin  50 右侧可能得菜单
 */
export const topBarMenuWidth = document.body.clientWidth - 200 - 20 - 36 - 20 - 20 - 120;

export const onlyShowContentMode = 'onlyContent';

export const notLoginPage = !loginPageRoutes.includes(window.location.pathname);


export const PRELOAD_BUNDLE = [
  'cloudViewAds.adsManagement',
  'cloudViewAds.overview',
  'cloudViewAds.home',
  'cloudViewAds.mediaLibrary',
  'cloudViewAds.adProduct',
  'cloudViewAds.adProductOverview',
  'cloudViewAds.setting',
];
